import * as React from "react";
import { Icon } from "@nju/icons";
import { Heading, HeadingProps } from "../Heading";
import { Text } from "../Text";

type ISideBoxProps =
  | {
      title?: string;
      isExpandable: boolean;
      isExpanded: boolean;
      variant?: HeadingProps["variant"];
      underline?: HeadingProps["underline"];
      testId?: string;
      extendedTitle?: undefined;
      children:
        | React.ReactNode
        | ((props: { isExpanded: boolean }) => React.ReactNode);
    }
  | {
      title?: string;
      variant?: HeadingProps["variant"];
      underline?: HeadingProps["underline"];
      isExpandable: false;
      testId?: string;
      isExpanded?: false;
      extendedTitle?: string;
      children: React.ReactNode;
    };

export function SideBox({
  title,
  testId,
  isExpandable,
  children,
  extendedTitle,
  isExpanded = false,
  variant = "h3",
  underline = "neutral",
}: ISideBoxProps) {
  const [expanded, setExpanded] = React.useState<boolean>(isExpanded);

  return (
    <div
      className="bg-porcelain rounded-[12px] px-3 py-2 mb-4 from-tablet:px-4 from-tablet:pt-4 from-tablet:pb-3 from-desktop:px-6 from-desktop:pb-3 relative"
      data-cy={testId}
    >
      {title && (
        <>
          <div className="flex flex-row justify-between items-center">
            {title && (
              <Heading
                className="font-bold text-size-24"
                font="ttfirs"
                tone="neutral"
                underline={underline}
                variant={variant}
              >
                {title}
              </Heading>
            )}
            {isExpandable && !extendedTitle && (
              <button
                className="bg-transparent border-none flex items-center cursor-pointer"
                onClick={() => {
                  setExpanded(!expanded);
                }}
              >
                <Text size="s" weight="bold">
                  {expanded ? "zwiń" : "rozwiń"}
                </Text>
                <Icon
                  className="flex-shrink-0 ml-[12px] w-[16px] h-[16px] from-tablet:ml-1 from-desktop:ml-[12px]"
                  name={expanded ? "chevron-up" : "chevron-down"}
                  tone="neutral"
                />
              </button>
            )}
            {!isExpandable && extendedTitle && (
              <Heading
                className="font-bold text-size-24"
                font="ttfirs"
                tone="neutral"
                variant="h4"
              >
                {extendedTitle}
              </Heading>
            )}
          </div>
        </>
      )}
      {typeof children === "function"
        ? children({ isExpanded: expanded })
        : children}
    </div>
  );
}
